import React from 'react';
import WhatsApp from '@mui/icons-material/WhatsApp';
import { ReactComponent as TwilioLogo } from '../../../assets/connectors/twilio.svg';
import { ReactComponent as AgencyZoomLogo } from '../../../assets/connectors/agencyzoom.svg';

/** Twilio, which takes the calls and carries the WhatsApp messages. */
export function TwilioMark({ size = 22 }: { size?: number }) {
  return <TwilioLogo width={size} height={size} />;
}

/** WhatsApp, in its own green. */
export function WhatsAppMark({ size = 22 }: { size?: number }) {
  return <WhatsApp sx={(t) => ({ fontSize: size, color: t.tokens.semantic.success })} />;
}

/** AgencyZoom, the agency's CRM, which holds the callbacks. */
export function AgencyZoomMark({ size = 22 }: { size?: number }) {
  return <AgencyZoomLogo width={size} height={size} />;
}
